<template>
    <!-- Form indicator  -->
    <div class="postition-relative w-100 text-center p-3">
        <p class="ml-1 mb-1 fw-bold" style="font-size: 0.75rem;">
            {{ `${currentStep}/${steps.length} ${steps[currentStep - 1]}` }}
        </p>
        <div class="workflow-indicator">
            <div class="workflow-indicator-line" v-for="(step, index) in steps" :key="index"
                :class="{ active: index < currentStep }" @click="emit('change-step', index + 1)">
            </div>
        </div>
    </div>
    <!-- Form indicator end -->
</template>

<script setup lang="ts">
import { watch } from 'vue';


const props = defineProps({
    currentStep: {
        type: Number,
        default: () => 0,
    },
    steps: {
        type: Array as () => string[],
        default: () => [],
    }
})

const emit = defineEmits<{ 
    // (e: 'update:currentStep', value: number): void 
    (e: 'change-step', value: number): void
}>()
</script>

<style scoped>
.sidemenu-header {
    text-align: center;
    margin-bottom: 1rem;
}

.workflow-indicator {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
}

.workflow-indicator-line {
    height: 0.5rem;
    width: 4rem;
    background-color: #ccc;
    margin: 0 3px;
    transition: background-color 0.3s ease;
    border-radius: 5px 5px 5px 5px;
    cursor: pointer;
}

.workflow-indicator-line.active {
    background-color: var(--color-primary);
}
</style>
